/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { countryControllerAddCountryPicture } from '../fn/country/country-controller-add-country-picture';
import { CountryControllerAddCountryPicture$Params } from '../fn/country/country-controller-add-country-picture';
import { countryControllerAddCountryPictureFromCloud } from '../fn/country/country-controller-add-country-picture-from-cloud';
import { CountryControllerAddCountryPictureFromCloud$Params } from '../fn/country/country-controller-add-country-picture-from-cloud';
import { countryControllerAssignCountriesToGroup } from '../fn/country/country-controller-assign-countries-to-group';
import { CountryControllerAssignCountriesToGroup$Params } from '../fn/country/country-controller-assign-countries-to-group';
import { countryControllerCreateCountryGroup } from '../fn/country/country-controller-create-country-group';
import { CountryControllerCreateCountryGroup$Params } from '../fn/country/country-controller-create-country-group';
import { countryControllerDeleteCountryGroup } from '../fn/country/country-controller-delete-country-group';
import { CountryControllerDeleteCountryGroup$Params } from '../fn/country/country-controller-delete-country-group';
import { countryControllerDeleteImage } from '../fn/country/country-controller-delete-image';
import { CountryControllerDeleteImage$Params } from '../fn/country/country-controller-delete-image';
import { countryControllerGetAll } from '../fn/country/country-controller-get-all';
import { CountryControllerGetAll$Params } from '../fn/country/country-controller-get-all';
import { countryControllerGetGroupsAndCountries } from '../fn/country/country-controller-get-groups-and-countries';
import { CountryControllerGetGroupsAndCountries$Params } from '../fn/country/country-controller-get-groups-and-countries';
import { countryControllerGetGroupsAndCountriesWithTravels } from '../fn/country/country-controller-get-groups-and-countries-with-travels';
import { CountryControllerGetGroupsAndCountriesWithTravels$Params } from '../fn/country/country-controller-get-groups-and-countries-with-travels';
import { countryControllerGetOne } from '../fn/country/country-controller-get-one';
import { CountryControllerGetOne$Params } from '../fn/country/country-controller-get-one';
import { countryControllerPublishGroup } from '../fn/country/country-controller-publish-group';
import { CountryControllerPublishGroup$Params } from '../fn/country/country-controller-publish-group';
import { countryControllerUpdate } from '../fn/country/country-controller-update';
import { CountryControllerUpdate$Params } from '../fn/country/country-controller-update';
import { CountryGroupResponse } from '../models/country-group-response';
import { CountryItem } from '../models/country-item';
import { CountryResponse } from '../models/country-response';

@Injectable({ providedIn: 'root' })
export class CountryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `countryControllerGetAll()` */
  static readonly CountryControllerGetAllPath = '/country';

  /**
   * Restituisce l'elenco dei paesi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetAll$Response(params?: CountryControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>> {
    return countryControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei paesi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetAll(params?: CountryControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryResponse;
}> {
    return this.countryControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>): BaseResponse & {
'data'?: CountryResponse;
} => r.body)
    );
  }

  /** Path part for operation `countryControllerGetOne()` */
  static readonly CountryControllerGetOnePath = '/country/{iso}';

  /**
   * Restituisce un Country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetOne$Response(params: CountryControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryItem;
}>> {
    return countryControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un Country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetOne(params: CountryControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryItem;
}> {
    return this.countryControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryItem;
}>): BaseResponse & {
'data'?: CountryItem;
} => r.body)
    );
  }

  /** Path part for operation `countryControllerUpdate()` */
  static readonly CountryControllerUpdatePath = '/country/{iso}';

  /**
   * Aggiorna un Country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerUpdate$Response(params: CountryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return countryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna un Country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerUpdate(params: CountryControllerUpdate$Params, context?: HttpContext): Observable<void> {
    return this.countryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `countryControllerAddCountryPicture()` */
  static readonly CountryControllerAddCountryPicturePath = '/country/{iso}/picture';

  /**
   * Foto profilo per il Country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerAddCountryPicture()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  countryControllerAddCountryPicture$Response(params: CountryControllerAddCountryPicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryItem;
}>> {
    return countryControllerAddCountryPicture(this.http, this.rootUrl, params, context);
  }

  /**
   * Foto profilo per il Country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerAddCountryPicture$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  countryControllerAddCountryPicture(params: CountryControllerAddCountryPicture$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryItem;
}> {
    return this.countryControllerAddCountryPicture$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryItem;
}>): BaseResponse & {
'data'?: CountryItem;
} => r.body)
    );
  }

  /** Path part for operation `countryControllerAddCountryPictureFromCloud()` */
  static readonly CountryControllerAddCountryPictureFromCloudPath = '/country/{iso}/picture-from-cloud';

  /**
   * Foto per il Country dal cloud.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerAddCountryPictureFromCloud()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerAddCountryPictureFromCloud$Response(params: CountryControllerAddCountryPictureFromCloud$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryItem;
}>> {
    return countryControllerAddCountryPictureFromCloud(this.http, this.rootUrl, params, context);
  }

  /**
   * Foto per il Country dal cloud.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerAddCountryPictureFromCloud$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerAddCountryPictureFromCloud(params: CountryControllerAddCountryPictureFromCloud$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryItem;
}> {
    return this.countryControllerAddCountryPictureFromCloud$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryItem;
}>): BaseResponse & {
'data'?: CountryItem;
} => r.body)
    );
  }

  /** Path part for operation `countryControllerDeleteImage()` */
  static readonly CountryControllerDeleteImagePath = '/country/{iso}/picture/{id}';

  /**
   * Elimina la foto del Country dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerDeleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerDeleteImage$Response(params: CountryControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return countryControllerDeleteImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina la foto del Country dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerDeleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerDeleteImage(params: CountryControllerDeleteImage$Params, context?: HttpContext): Observable<void> {
    return this.countryControllerDeleteImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `countryControllerGetGroupsAndCountries()` */
  static readonly CountryControllerGetGroupsAndCountriesPath = '/country/group';

  /**
   * Restituisce l'elenco dei gruppi e dei paesi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerGetGroupsAndCountries()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetGroupsAndCountries$Response(params?: CountryControllerGetGroupsAndCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryGroupResponse;
}>> {
    return countryControllerGetGroupsAndCountries(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei gruppi e dei paesi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerGetGroupsAndCountries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetGroupsAndCountries(params?: CountryControllerGetGroupsAndCountries$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryGroupResponse;
}> {
    return this.countryControllerGetGroupsAndCountries$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryGroupResponse;
}>): BaseResponse & {
'data'?: CountryGroupResponse;
} => r.body)
    );
  }

  /** Path part for operation `countryControllerCreateCountryGroup()` */
  static readonly CountryControllerCreateCountryGroupPath = '/country/group';

  /**
   * Crea un gruppo per i Country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerCreateCountryGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerCreateCountryGroup$Response(params: CountryControllerCreateCountryGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return countryControllerCreateCountryGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un gruppo per i Country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerCreateCountryGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerCreateCountryGroup(params: CountryControllerCreateCountryGroup$Params, context?: HttpContext): Observable<void> {
    return this.countryControllerCreateCountryGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `countryControllerDeleteCountryGroup()` */
  static readonly CountryControllerDeleteCountryGroupPath = '/country/group/{id}';

  /**
   * Elimina un CountryGroup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerDeleteCountryGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerDeleteCountryGroup$Response(params: CountryControllerDeleteCountryGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return countryControllerDeleteCountryGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un CountryGroup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerDeleteCountryGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerDeleteCountryGroup(params: CountryControllerDeleteCountryGroup$Params, context?: HttpContext): Observable<void> {
    return this.countryControllerDeleteCountryGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `countryControllerAssignCountriesToGroup()` */
  static readonly CountryControllerAssignCountriesToGroupPath = '/country/group/{id}';

  /**
   * Assegna Countries a un CountryGroup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerAssignCountriesToGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerAssignCountriesToGroup$Response(params: CountryControllerAssignCountriesToGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return countryControllerAssignCountriesToGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Assegna Countries a un CountryGroup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerAssignCountriesToGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerAssignCountriesToGroup(params: CountryControllerAssignCountriesToGroup$Params, context?: HttpContext): Observable<void> {
    return this.countryControllerAssignCountriesToGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `countryControllerPublishGroup()` */
  static readonly CountryControllerPublishGroupPath = '/country/group/{id}/publish';

  /**
   * Assegna il flag published a un CountryGroup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerPublishGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerPublishGroup$Response(params: CountryControllerPublishGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return countryControllerPublishGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Assegna il flag published a un CountryGroup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerPublishGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  countryControllerPublishGroup(params: CountryControllerPublishGroup$Params, context?: HttpContext): Observable<void> {
    return this.countryControllerPublishGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `countryControllerGetGroupsAndCountriesWithTravels()` */
  static readonly CountryControllerGetGroupsAndCountriesWithTravelsPath = '/country/group/active';

  /**
   * Restituisce l'elenco dei gruppi e dei paesi con viaggi attivi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryControllerGetGroupsAndCountriesWithTravels()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetGroupsAndCountriesWithTravels$Response(params?: CountryControllerGetGroupsAndCountriesWithTravels$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryGroupResponse;
}>> {
    return countryControllerGetGroupsAndCountriesWithTravels(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei gruppi e dei paesi con viaggi attivi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryControllerGetGroupsAndCountriesWithTravels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryControllerGetGroupsAndCountriesWithTravels(params?: CountryControllerGetGroupsAndCountriesWithTravels$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryGroupResponse;
}> {
    return this.countryControllerGetGroupsAndCountriesWithTravels$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryGroupResponse;
}>): BaseResponse & {
'data'?: CountryGroupResponse;
} => r.body)
    );
  }

}
